import {getActivePayOrder} from './api.js'
import util from './util.js'
var Pingpp = require('pingpp-js')
 import wx from 'weixin-js-sdk'
//import wx from "jweixin-1.6.0";
// 拼++ 支付
var pay = (params, header, callBack, failFun, cancelFun,changeFun) => {
  util.showLoading()
  getActivePayOrder(params, header).then(res => {
    console.log(res)
    if (res.res.code === 10000 && res.body) {
      util.hideLoading()
      if(res.body.payType == '7'){
        wx.chooseWXPay({
          timestamp: res.body.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: res.body.nonceStr, // 支付签名随机串，不长于 32 位
          package: res.body.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: res.body.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: res.body.sign, // 支付签名
          success: function () {
            // 支付成功后的回调函数
            typeof callBack === 'function' && callBack()
          },
          error: function () {
            // 支付失败后的回调函数
            typeof callBack === 'function' && failFun()
          },
          cancel: function() {
            typeof callBack === 'function' && cancelFun()
          }
        });
      }else{
        Pingpp.createPayment(res.body, function (result) {
          if (result === 'success') {
            util.showToast('支付成功')
            typeof callBack === 'function' && callBack()
          } else if (result === 'fail') {
            util.showToast('支付失败')
            typeof callBack === 'function' && failFun()
          } else if (result === 'cancel') {
            util.showToast('已取消支付')
            typeof callBack === 'function' && cancelFun()
          }
        });
      }
    } else if(res.res.code === 10009){//订单状态已变更
      typeof changeFun === 'function' && changeFun()
    }else{
      util.hideLoading()
      if(params.payType == '6'){
        typeof callBack === 'function' && callBack()
      }else{
        typeof callBack === 'function' && callBack()
        util.showToast(res.res.msg, 2000)
      }
    }
  })
}

export default pay;
